import axios from 'axios';
import store from './store'
import router from './router'
const req_url = store.state.req_url

export default async(type='get', url = '', data = {}, cb) => {
	let res
	let config = {
		 headers:{'content-Type': 'application/json; charset=UTF-8'}
	}
	if (type=='get') {
		await axios.get(req_url + url).then(response =>{ res = response})
			          .catch(error => {
									cb(error)
								})
	}else{
			await axios.post(req_url + url, JSON.stringify(data), config).then(response =>{
								res = response
						}).catch(error => {
							cb(error)
						})
	}
	if (res.data.code == 1000) {
		store.commit('updateUserKey', '')
		localStorage.removeItem('user_key')
		store.commit('updateUser', '')
		localStorage.removeItem('user')
		store.commit('updateUserMobile', '')
		localStorage.removeItem('user_mobile')
		router.replace({name: 'Main'})
		return await res.data
	}
	return await res.data
}
